var _rect, _g, _rect2, _rect3, _rect4, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAukkotehtavatIkoni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 57,
    viewBox: "0 0 170 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 169,
    height: 22,
    rx: 1.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169 1H148V22H169V1Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 15.6687L153.962 7.80786H158.5H163.039L160.77 11.7384L158.5 15.6687Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.555618
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 169,
    height: 22,
    rx: 1.5,
    stroke: "#444444"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 34.5,
    width: 169,
    height: 22,
    rx: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 34.5,
    width: 169,
    height: 22,
    rx: 1.5,
    stroke: "#444444"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(148 1)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAukkotehtavatIkoni);
export default __webpack_public_path__ + "static/media/Aukkotehtävät_ikoni.de2183672772ff3f0bace3338ace66ef.svg";
export { ForwardRef as ReactComponent };